import { action, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { SessionShowView } from '../../../../types/sessions';
import { SessionId } from '../../../../../commonv3/types/sessions';
import { SessionApis } from '../../../../apis/sessions';
import { EventCategory, SheEventClient } from '../../../../../commonv3/events/SheEventClient';

export class SessionReservationEvaluationPaneState {
    @observable sessionId: SessionId = null;
    @observable session: RemoteResourceV3<SessionShowView> = RemoteResourceV3.loading();
    @observable submitting: boolean = false;

    @action.bound
    async init(sessionId: SessionId): Promise<void> {
        this.sessionId = sessionId;
        const session = await this.reloadSession();
        if (session) {
            SheEventClient.reportEvent(EventCategory.SESSION, 'evaluation_requested', session);
        }
    }

    @action.bound
    async reloadSession() {
        return await updateRemoteResourceV3(
            this.session,
            (v) => (this.session = v),
            () => SessionApis.show(this.sessionId)
        );
    }
}
